//Global imports
import React from 'react';
import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
} from '@coreui/react';

//File imports
import { Language } from '../../language/English';

interface FieldPreviewModalProps {
    visible: boolean;
    onClose: () => void;
    title?: string;
    imageSrc: string;
}

const FieldPreviewModal: React.FC<FieldPreviewModalProps> = ({
    visible,
    onClose,
    title = Language.WHERE_THIS_APPEARS_ON_WEBSITE,
    imageSrc,
}) => {
    return (
        <CModal
            alignment="center"
            visible={visible}
            onClose={onClose}
            size="lg"
        >
            <CModalHeader>
                <CModalTitle>{title}</CModalTitle>
            </CModalHeader>

            <CModalBody className="text-center">
                <img
                    src={imageSrc}
                    alt={`${imageSrc} Field Preview`}
                    className="img-fluid rounded shadow-sm"
                />
                <p className="text-muted mt-2 mb-0 fs-6">
                    {Language.FIELD_PREVIEW_DESCRIPTION}
                </p>
            </CModalBody>

            <CModalFooter>
                <CButton color="secondary" onClick={onClose}>
                    {Language.CLOSE}
                </CButton>
            </CModalFooter>
        </CModal>
    );
};

export default FieldPreviewModal;
